import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["onClick"]
const _hoisted_2 = {
  key: 0,
  class: "text-sm font-medium mt-4"
}
const _hoisted_3 = { class: "max-w-[1040px]" }
const _hoisted_4 = { class: "flex items-center justify-between gap-6" }
const _hoisted_5 = {
  key: 0,
  class: "space-y-6 border-t border-gray-100 pt-5"
}
const _hoisted_6 = {
  id: "linkable-permissions",
  class: "scroll-mt-10"
}
const _hoisted_7 = { class: "mt-4 flex" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "font-semibold text-gray-700" }
const _hoisted_10 = { class: "font-semibold text-gray-700" }
const _hoisted_11 = { class: "flex justify-end" }
const _hoisted_12 = {
  key: 0,
  class: "mt-4 ml-4 max-w-sm border-l border-gray-200 pl-5"
}

import { MenuItem } from '@headlessui/vue'
import { XCircleIcon } from '@heroicons/vue/24/outline'
import { computed, inject, reactive, ref } from 'vue'
import { useRoute } from 'vue-router'

import NeueButton from '@/components/neue/NeueButton'
import NeueLoading from '@/components/neue/NeueLoading'
import NeueToggle from '@/components/neue/NeueToggle'
import SettingsSection from '@/components/neue/SettingsSection.vue'
import TablistGrid from '@/components/neue/TablistGrid.vue'
import api from '@/store/api'
import { mapRelationship, mapRelationships, mapType } from '@/store/mappers'


export default {
  __name: 'StorePermissions',
  props: ['id'],
  setup(__props) {

const bus = inject('bus')
const accessLoading = ref(true)
const props = __props
const route = useRoute()
const store = computed(() => mapRelationship({ type: 'store', id: props.id }))
const isCateringStore = computed(() => store.value?.attributes?.platform === 'catering')

const modalOpen = ref(false)
const addingPermission = ref(null)
const editingPermission = ref(null)
const userResults = ref([])

const access = reactive({
  visible: null,
  locked: null,
  allowPassword: null,
  password: ''
})
const tiers = computed(() => mapType('membership_tier'))
const pairs = computed(() => mapType('conversation_user_pair'))
const permissions = computed(() => mapRelationships(store.value?.relationships.permissions.data))

api.call('GET', `stores/${route.params.id}?included=none`).then(() => {
  accessLoading.value = false
  discardAccess()
})
api.call('GET', `stores/${route.params.id}/permissions`)
api.call('GET', 'membership_tiers?included=none')
api.call('GET', 'conversation_user_pairs?included=none')

const discardAccess = () => {
  access.visible = store.value.attributes.is_public
  access.locked = store.value.attributes.locked
  access.allowPassword = store.value.attributes.allow_password_access
  access.password = store.value.attributes.simple_password
}

const setVisible = value => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      is_public: value
    }
  })
}

const setLocked = value => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      locked: value
    }
  })
}

const setAllowPassword = value => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      allow_password_access: value
    }
  })
}

const dirty = () => bus.emit('dirty/store', { from: 'basics' })

bus.on('save/store', () => {
  api.call('PUT', `stores/${props.id}?included=none`, {
    store: {
      simple_password: access.password
    }
  })
})

bus.on('discard/store', discardAccess)

const addPermission = () => {
  api
    .call(
      'POST',
      `stores/${route.params.id}/permissions`,
      {
        permission: {
          ...(addingPermission.value === 'tier'
            ? {
                permission_class_name: 'MembershipTier',
                type_of_permission: 'membership_tier'
              }
            : {
                permission_class_name: 'ConversationUserPair',
                type_of_permission: 'user'
              }),
          permission_id: null
        }
      },
      { save: false }
    )
    .then(x => {
      editPermission(
        mapRelationships(x.data.data.relationships.permissions.data)
          .sort((a, b) => a.id - b.id)
          .pop()
      )
      editingPermission.value.new = true
    })
}

const closeModal = () => {
  if (editingPermission.value.new) deletePermission(editingPermission.value)
  modalOpen.value = false
}

const deletePermission = permission =>
  api.call('DELETE', `stores/${route.params.id}/permissions/${permission.id}`, {}, { delete: false })

const editPermission = permission => {
  editingPermission.value = {
    id: permission.id,
    type: permission.attributes.type_of_permission === 'membership_tier' ? 'tier' : 'user',
    objectId: permission.attributes.permission_id?.toString() ?? null
  }
  modalOpen.value = true
}

const savePermission = () => {
  api.call('PUT', `stores/${route.params.id}/permissions/${editingPermission.value.id}`, {
    permission: {
      id: editingPermission.value.id,
      permission_id: editingPermission.value.objectId
    }
  })
  modalOpen.value = false
}

return (_ctx, _cache) => {
  const _component_SelectInput = _resolveComponent("SelectInput")
  const _component_FormElement = _resolveComponent("FormElement")
  const _component_InlineSearchSelect = _resolveComponent("InlineSearchSelect")
  const _component_FormSection = _resolveComponent("FormSection")
  const _component_TheModal = _resolveComponent("TheModal")
  const _component_TablistHeader = _resolveComponent("TablistHeader")
  const _component_TablistRow = _resolveComponent("TablistRow")
  const _component_NeueTablist = _resolveComponent("NeueTablist")
  const _component_InputField = _resolveComponent("InputField")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheModal, {
      "is-open": modalOpen.value,
      "modal-title": editingPermission.value?.new ? 'Add permission' : 'Edit permission',
      onCloseModal: closeModal
    }, {
      main: _withCtx(() => [
        _createVNode(_component_FormSection, null, {
          default: _withCtx(() => [
            (editingPermission.value.type === 'tier')
              ? (_openBlock(), _createBlock(_component_FormElement, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectInput, {
                      modelValue: editingPermission.value.objectId,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((editingPermission.value.objectId) = $event)),
                      options: tiers.value?.map(x => ({ name: x.attributes.tier_name, value: x.id })),
                      name: "Membership tier to allow",
                      placeholder: "Choose a membership tier"
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_FormElement, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_InlineSearchSelect, {
                      "helper-text": { typingPrompt: 'Find user to allow', noResult: 'No users found' },
                      "local-search-options": pairs.value,
                      "fuse-options": { keys: ['attributes.display_name'] },
                      onOnResults: _cache[1] || (_cache[1] = x => (userResults.value = x))
                    }, {
                      searchResults: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userResults.value, ({ item }) => {
                          return (_openBlock(), _createBlock(_unref(MenuItem), {
                            key: item.id
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("button", {
                                class: "group rounded-md w-full px-2 py-2 text-sm text-left hover:bg-gray-100 duration-200 transition-colors text-gray-700",
                                onClick: $event => (editingPermission.value.objectId = item.id)
                              }, _toDisplayString(item.attributes.display_name), 9, _hoisted_1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["local-search-options"]),
                    (editingPermission.value.objectId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(mapRelationship)({ type: 'conversation_user_pair', id: editingPermission.value.objectId }).attributes
                .display_name), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        })
      ]),
      footer: _withCtx(() => [
        _createVNode(_unref(NeueButton), {
          type: "secondary",
          onClick: closeModal
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_unref(NeueButton), {
          type: editingPermission.value.objectId ? 'primary' : 'inactive',
          onClick: savePermission
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
            _createTextVNode("Save", -1)
          ]))]),
          _: 1
        }, 8, ["type"])
      ]),
      _: 1
    }, 8, ["is-open", "modal-title"]),
    _createVNode(_unref(NeueLoading), { loading: accessLoading.value }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(SettingsSection, {
            title: "Store visibility",
            description: "Who can find this store, and how they reach it.",
            flush: ""
          }, {
            default: _withCtx(() => [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "min-w-0" }, [
                _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Visible in the store list"),
                _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " Visible stores appear on the product selection page. Private stores can be shared with a unique link. ")
              ], -1)),
              _createVNode(_unref(NeueToggle), {
                modelValue: access.visible,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((access.visible) = $event)),
                onChange: setVisible
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          (!isCateringStore.value)
            ? (_openBlock(), _createBlock(SettingsSection, {
                key: 0,
                title: "Locked store",
                description: "Lock the store so only the customers and membership tiers you choose can open it."
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "min-w-0" }, [
                      _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 mb-1" }, "Locked"),
                      _createElementVNode("p", { class: "text-[13px] leading-relaxed text-gray-500" }, " When locked, a lock icon appears in front of the store and customers cannot open it. They can log in, or contact you to request access. ")
                    ], -1)),
                    _createVNode(_unref(NeueToggle), {
                      modelValue: access.locked,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((access.locked) = $event)),
                      onChange: setLocked
                    }, null, 8, ["modelValue"])
                  ]),
                  (access.locked)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _cache[16] || (_cache[16] = _createElementVNode("h3", { class: "text-sm font-semibold leading-6 text-gray-900" }, "Permissions", -1)),
                          _cache[17] || (_cache[17] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, "Grant access to specific customers and membership tiers.", -1)),
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_SelectInput, {
                              modelValue: addingPermission.value,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((addingPermission).value = $event)),
                              placeholder: "Choose a permission type",
                              options: [
                  { name: 'Allow membership tier', value: 'tier' },
                  { name: 'Allow user', value: 'user' }
                ],
                              class: "flex-grow"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_unref(NeueButton), {
                              class: "ml-4",
                              type: addingPermission.value ? 'secondary' : 'inactive',
                              onClick: addPermission
                            }, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode(" + Permission ", -1)
                              ]))]),
                              _: 1
                            }, 8, ["type"])
                          ]),
                          (permissions.value.length)
                            ? (_openBlock(), _createBlock(_component_NeueTablist, {
                                key: 0,
                                class: "mt-4"
                              }, {
                                head: _withCtx(() => [
                                  _createVNode(_component_TablistHeader, null, {
                                    default: _withCtx(() => [
                                      _createVNode(TablistGrid, {
                                        columns: ['Permission', ''],
                                        header: ""
                                      }, {
                                        default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                                          _createElementVNode("div", null, "Permission", -1),
                                          _createElementVNode("div", null, null, -1)
                                        ]))]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(permissions.value, (permission) => {
                                    return (_openBlock(), _createBlock(_component_TablistRow, {
                                      key: permission.id
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(TablistGrid, {
                                          columns: ['Permission', ''],
                                          class: "items-center"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("div", {
                                              class: "cursor-pointer truncate",
                                              onClick: $event => (editPermission(permission))
                                            }, [
                                              (permission.attributes.type_of_permission === 'membership_tier')
                                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                    _cache[13] || (_cache[13] = _createTextVNode(" Allow ", -1)),
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(mapRelationship)({ type: 'membership_tier', id: permission.attributes.permission_id })
                            ?.attributes.tier_name), 1),
                                                    _cache[14] || (_cache[14] = _createTextVNode(" members ", -1))
                                                  ], 64))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                    _cache[15] || (_cache[15] = _createTextVNode(" Allow ", -1)),
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(mapRelationship)({ type: 'conversation_user_pair', id: permission.attributes.permission_id })
                            ?.attributes.display_name), 1)
                                                  ], 64))
                                            ], 8, _hoisted_8),
                                            _createElementVNode("div", _hoisted_11, [
                                              _createVNode(_unref(XCircleIcon), {
                                                class: "h-5 w-5 cursor-pointer text-gray-700",
                                                onClick: $event => (deletePermission(permission))
                                              }, null, 8, ["onClick"])
                                            ])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_unref(NeueToggle), {
                            modelValue: access.allowPassword,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((access.allowPassword) = $event)),
                            name: "Require a password",
                            description: "Leave it off and only the customers and membership tiers under Permissions can get in.",
                            onChange: setAllowPassword
                          }, null, 8, ["modelValue"]),
                          (access.allowPassword)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _cache[18] || (_cache[18] = _createElementVNode("h3", { class: "text-sm font-medium leading-6 text-gray-900" }, "Set password", -1)),
                                _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-500" }, " Customers see a password box on the locked store. Set a password and save, otherwise nobody can get in. ", -1)),
                                _createVNode(_component_InputField, {
                                  modelValue: access.password,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((access.password) = $event)),
                                  class: "password mt-3",
                                  "aria-label": "Set password",
                                  onInput: dirty
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["loading"])
  ], 64))
}
}

}